//
//
//
//
//
//
//
//
//


export default {
    name: "BottomNav",

    data() {
        return {
            active: 0,

        };
    },
    methods: {},
    //通过路由跳转判断选中的样式
    created() {
        if (this.$route.name === "workSheets") {
            this.active = 0;
        } else if (this.$route.name === "activeScan") {
            this.active = 1;
        } else if (this.$route.name === "noticeSheet") {
            this.active = 2;
        } else if (this.$route.name === "userSheet") {
            this.active = 3;
        }
    }
};
